import { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react';
import { cx } from '#shared/cx';

type ButtonType = 'button' | 'submit' | 'reset';

type CommonProps = {
  className?: string;
  children?: React.ReactNode;
};

export type ButtonVariantProps = CommonProps & {
  asLink?: false;
  type?: ButtonType;
  minimal?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

type AnchorVariantProps = CommonProps & {
  asLink: true;
  minimal?: boolean;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

type Props = ButtonVariantProps | AnchorVariantProps;

export const Button = (props: Props) => {
  if (props.asLink) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { className, children, asLink, minimal, ...rest } = props;
    return (
      <a {...rest} className={cx(!minimal && 'btn-flat', className)}>
        {children}
      </a>
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { className, children, type = 'button', minimal, asLink, ...rest } = props;
  return (
    <button type={type} {...rest} className={cx(!minimal && 'btn-flat', className)}>
      {children}
    </button>
  );
};
